export enum ApiRecentKey {
  country = "country",
  currency = "currency",
}

export type ApiRecentPayload = {
  type: ApiRecentKey;
  values: Array<string | number>;
};

export type ApiRecentUpdate = {
  entities: ApiRecentPayload[];
};

export type ApiRecent = {
  entities: ApiRecentPayload[];
};
